import { ICreateControleAguaUseCase } from "../../../presentation/useCases/create/create_controle_agua_use_case";
import { CreateControleAguaRequestModel, CreateControleAguaResponseModel } from "../../models/obras_sustentabilidade_model";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * CreateControleAguaUseCase
 */

export class CreateControleAguaUseCase implements ICreateControleAguaUseCase {
  constructor(private readonly repository: IObrasRepository) {}

  async createControleAgua(model: CreateControleAguaRequestModel): Promise<CreateControleAguaResponseModel> {
    return await this.repository.createControleAgua(model);
  }
}
